module.exports = __webpack_public_path__ + "static/media/ic-mblock-logo.d4d9a4e9.svg";